'use strict';

define('vb/private/stateManagement/switcherHistory',[
  'vb/private/history',
], (History) => {
  /**
   * An implementation of the History class that does not alter the URL
   */
  class SwitcherHistory extends History {
    // eslint-disable-next-line no-unused-vars
    static addUrlParameter(name, value) {
    }

    // eslint-disable-next-line no-unused-vars
    static setUrlParameter(name, value) {
    }

    static setUrl() {
    }
  }

  return SwitcherHistory;
});

